import { object } from '@calendly/form/validation'

import {
  formatIncrementsValues,
  formatLockTimezoneValues,
  getIncrementsInitialValues,
  getIncrementsValidationSchema,
  getLockTimezoneInitialValues
} from 'components/event_type_edit'

import {
  getBookingLinkInitialValues,
  getBookingLinkValidationSchema,
  getFormatBookingLinkValues
} from '../booking_link'

export const getInitialValues = (eventType) => ({
  ...getBookingLinkInitialValues(eventType),
  ...getIncrementsInitialValues(eventType),
  ...getLockTimezoneInitialValues(eventType),
})

export const getFormatValuesToServerData = (eventType) => (values) => {
  const formatBookingLinkValues = getFormatBookingLinkValues(eventType)


  return {
    ...formatBookingLinkValues(values),
    ...formatIncrementsValues(values),
    ...formatLockTimezoneValues(values)
  }
}

export const getValidationSchema = (eventType) => object({})
  .concat(getBookingLinkValidationSchema(eventType))
  .concat(getIncrementsValidationSchema())
